import { HttpClient } from '@adapters/HttpClient';
import { LocationOrdersModel } from '../models/LocationOrders';

export interface LocationOrdersFilters {
  search?: string;
  status?: string;
  from_date?: string; // formato YYYY-MM-DD
  to_date?: string; // formato YYYY-MM-DD
  order_type?: string; // "picking_return"
  page?: number;
  limit?: number;
}

export interface LocationOrdersPage {
  locationorders: LocationOrdersModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class LocationOrdersApiAdapter {
  constructor(private httpClient: HttpClient) { }

  async getLocationOrdersPaginated(
    filters: LocationOrdersFilters = {}
  ): Promise<LocationOrdersPage> {
    const {
      search,
      status,
      from_date,
      to_date,
      page = 1,
      limit = 15,
    } = filters;

    // Parámetros simples para el endpoint
    const params: any = {
      ...(search && { search }),
      ...(status && { status }),
      ...(from_date && { from_date }),
      ...(to_date && { to_date }),
      page,
      per_page: limit,
    };

    // Solo mostrar loading global para la primera página
    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<any>('/location-orders', params, {}, showGlobalLoading);

    return {
      locationorders: response.data,
      nextPage:
        response.meta.currentPage < response.meta.lastPage
          ? response.meta.currentPage + 1
          : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
    };
  }

  async getAll(): Promise<LocationOrdersModel[]> {
    const response = await this.getLocationOrdersPaginated();
    return response.locationorders;
  }
}
